import { path } from 'chromedriver'

export default [
  {
    path: '/admin/apply/wechat/officialAccount/basicSettings',
    name: 'wechatOfficialAccountBasicSettings',
    component: () => import('@/views/apply/wechat/officialAccount/basicSettings.vue'),
    meta: {
      title: '公众号基础设置',
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/wechat/officialAccount/templateMessage',
    name: 'wechatMiniprogramTemplateMessage',
    component: () => import('@/views/apply/wechat/officialAccount/templateMessage.vue'),
    meta: {
      title: '模板消息',
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/wechat/officialAccount/customizeMenu',
    name: 'wechatOfficialAccountCustomizeMenu',
    component: () => import('@/views/apply/wechat/officialAccount/customizeMenu'),
    meta: {
      title: '公众号自定义菜单',
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/wechat/officialAccount/automaticReply',
    name: 'wechatOfficialAccountAutomaticReply',
    component: () => import('@/views/apply/wechat/officialAccount/autoReply/index'),
    meta: {
      title: '公众号自动回复',
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/wechat/miniprogram/basicSettings',
    name: 'wechatMiniprogramBasicSettings',
    component: () => import('@/views/apply/wechat/miniprogram/basicSettings.vue'),
    meta: {
      title: '小程序基础设置',
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/wechat/miniprogram/publishMiniProgram',
    name: 'wechatMiniprogramPublishMiniProgram',
    component: () => import('@/views/apply/wechat/miniprogram/publishMiniProgram.vue'),
    meta: {
      title: '小程序发布',
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/wechat/miniprogram/orderList',
    name: 'wechatMiniprogramOrderList',
    component: () => import('@/views/apply/wechat/miniprogram/orderList.vue'),
    meta: {
      title: '发货信息管理',
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/wechat/miniprogram/forwardingSettings',
    name: 'wechatMiniprogramForwardingSettings',
    component: () => import('@/views/apply/wechat/miniprogram/forwardingSettings.vue'),
    meta: {
      title: '转发设置',
      headType: 0,
      auth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/apply/wechat.js